var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.33366H11.3333V4.00033C11.3333 2.16033 9.84 0.666992 8 0.666992C6.16 0.666992 4.66667 2.16033 4.66667 4.00033V5.33366H4.00001C3.26667 5.33366 2.66667 5.93366 2.66667 6.66699V13.3337C2.66667 14.067 3.26667 14.667 4.00001 14.667H12C12.7333 14.667 13.3333 14.067 13.3333 13.3337V6.66699C13.3333 5.93366 12.7333 5.33366 12 5.33366ZM8 11.3337C7.26667 11.3337 6.66667 10.7337 6.66667 10.0003C6.66667 9.26699 7.26667 8.66699 8 8.66699C8.73334 8.66699 9.33334 9.26699 9.33334 10.0003C9.33334 10.7337 8.73334 11.3337 8 11.3337ZM10.0667 5.33366H5.93334V4.00033C5.93334 2.86033 6.86 1.93366 8 1.93366C9.14 1.93366 10.0667 2.86033 10.0667 4.00033V5.33366Z",
    fill: "#8CA1B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockInput);
export default __webpack_public_path__ + "static/media/lock-input.67296bfddbc44f86c420a65cf286c404.svg";
export { ForwardRef as ReactComponent };